import {
  Home,
  Users,
  Building,
  Building2,
  FileText,
  Calendar,
  Mail,
  Phone,
  DollarSign,
  BarChart3,
  Settings,
  Shield,
  Clock,
  Archive,
  MessageSquare,
  Bell,
  User,
  Briefcase,
  CreditCard,
  Truck,
  Package,
  Target,
  TrendingUp,
  FileBarChart,
  Database,
  Globe,
  HelpCircle,
  BookOpen,
  Wrench,
  Palette,
  Circle,
  ChevronRight,
  Plus,
  Search,
  Filter,
  Edit,
  Trash2,
  Download,
  Upload,
  Save,
  Copy,
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Check,
  X,
  AlertCircle,
  Info,
  Star,
  Heart,
  Share,
  Link,
  ExternalLink,
  Menu,
  MoreHorizontal,
  MoreVertical,
  Grid,
  List,
  Layout,
  LayoutDashboard,
  Maximize,
  Minimize,
  RotateCcw, // Verwende RotateCcw statt Refresh
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  // Menu Builder Icons (Lucide)
  Gift,
  ShoppingCart,
  Map,
  Calculator,
  Receipt,
  Table,
  FileSignature,
  HandCoins,
  Zap,
  Store,
  UserCircle,
  UserCog,
  // Additional Lucide Icons for Menu Builder
  Activity,
  Scale,
  Send,
  Folder,
  FolderOpen,
  Image,
  Video,
  Music,
  Box,
  Boxes,
  Layers,
  PenTool,
  Scissors,
  Clipboard,
  ClipboardList,
  ClipboardCheck,
  Bookmark,
  Tag,
  Tags,
  Hash,
  AtSign,
  Smile,
  Frown,
  Meh,
  ThumbsUp,
  ThumbsDown,
  Award,
  Medal,
  Trophy,
  Crown,
  Flame,
  Sparkles,
  Lightbulb,
  Power,
  Battery,
  Wifi,
  Bluetooth,
  Headphones,
  Speaker,
  Monitor,
  Laptop,
  Smartphone,
  Tablet,
  Printer,
  HardDrive,
  Cpu,
  Server,
  Cloud,
  CloudDownload,
  CloudUpload,
  Coffee,
  Utensils,
  Pizza,
  Apple,
  Leaf,
  Sun,
  Moon,
  CloudRain,
  Snowflake,
  Wind,
  Thermometer,
  Droplet,
  Umbrella,
  Compass,
  MapPin,
  Navigation,
  Plane,
  Car,
  Bus,
  Train,
  Ship,
  Anchor,
  Bike,
  Key,
  Wallet,
  Banknote,
  Coins,
  PiggyBank,
  ChartLine,
  ChartPie,
  TrendingDown,
  Percent,
  Binary,
  Code,
  Terminal,
  Bug,
  Rocket,
  Gauge,
  Sliders,
  ToggleLeft,
  ToggleRight,
  RefreshCw,
  RotateCw,
  Repeat,
  Shuffle,
  Play,
  Pause,
  Square,
  StepForward,
  StepBack,
  FastForward,
  Rewind,
  Volume,
  Volume1,
  Volume2,
  VolumeX,
  Mic,
  MicOff,
  Camera,
  CameraOff,
  Film,
  Aperture,
  Focus,
  Crop,
  Move,
  Maximize2,
  Minimize2,
  ZoomIn,
  ZoomOut,
  CornerUpLeft,
  CornerUpRight,
  CornerDownLeft,
  CornerDownRight,
  ChevronsUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ArrowUpRight,
  ArrowDownRight,
  ArrowUpLeft,
  ArrowDownLeft,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Type,
  Heading1,
  Heading2,
  Heading3,
  ListOrdered,
  ListTodo,
  Quote,
  Code2,
  FileCode,
  FileJson,
  FileSpreadsheet,
  FileImage,
  FileVideo,
  FileAudio,
  FileArchive,
  FilePlus,
  FileMinus,
  FileCheck,
  FileX,
  FolderPlus,
  FolderMinus,
  FolderCheck,
  FolderX,
  Trash,
  Link2,
  Link2Off,
  Unlink,
  Paperclip,
  Pin,
  PinOff,
  Flag,
  Milestone,
  SignalHigh,
  SignalMedium,
  SignalLow,
  WifiOff,
  Radio,
  Tv,
  Tv2,
  Cable,
  Plug,
  PlugZap,
  BatteryCharging,
  BatteryFull,
  BatteryMedium,
  BatteryLow,
  BatteryWarning,
  QrCode,
  Barcode,
  Scan,
  ScanLine,
  UserCheck,
  UserMinus,
  UserPlus,
  UserX,
  Users2,
  UsersRound,
  UserRound,
  Contact,
  Contact2,
  CircleUser,
  BadgeCheck,
  BadgeAlert,
  BadgeDollarSign,
  BadgePercent,
  BadgePlus,
  BadgeMinus,
  BadgeX,
  Verified,
  ShieldCheck,
  ShieldX,
  ShieldOff,
  ShieldQuestion,
  LockKeyhole,
  UnlockKeyhole,
  KeyRound,
  KeySquare,
  Fingerprint
} from 'lucide-react';

// Alias für Refresh
const Refresh = RotateCcw;

// Bootstrap Icons Unterstützung (bi / bootstrap / bs)
const BOOTSTRAP_ICON_PREFIXES = ['bi', 'bootstrap', 'bs'];
const FA_PREFIXES = ['fa', 'fas', 'far', 'fal', 'fad', 'fab'];

// Korrekturen für häufig falsch benannte Bootstrap Icons
const BOOTSTRAP_ICON_RENAMES = {
  'bi-bolt': 'bi-lightning',
  'bi-bolt-fill': 'bi-lightning-fill',
  'bi-bolt-charge': 'bi-lightning-charge',
  'bi-bolt-charge-fill': 'bi-lightning-charge-fill',
};

function applyBootstrapRenames(biClassName) {
  return BOOTSTRAP_ICON_RENAMES[biClassName] || biClassName;
}

// Alias-Mapping: generische Namen -> Bootstrap Icon Klassen
const BOOTSTRAP_ICON_ALIAS = {
  // Haupt-Bereiche
  'home': 'bi-house',
  'dashboard': 'bi-speedometer2',
  'house': 'bi-house',
  'users': 'bi-people',
  'user': 'bi-person',
  'building': 'bi-building',
  'company': 'bi-building',
  'unternehmen': 'bi-building',

  // Aktivitäten
  'calendar': 'bi-calendar3',
  'termine': 'bi-calendar3',
  'clock': 'bi-clock',
  'time': 'bi-clock',
  'aufgaben': 'bi-clock',
  'tasks': 'bi-clock',

  // Kommunikation
  'mail': 'bi-envelope',
  'email': 'bi-envelope',
  'phone': 'bi-telephone',
  'telefon': 'bi-telephone',
  'message-square': 'bi-chat-left-text',
  'messages': 'bi-chat-left-text',
  'nachrichten': 'bi-chat-left-text',
  'chat': 'bi-chat-left-text',
  'bell': 'bi-bell',
  'notifications': 'bi-bell',

  // Dokumente & Dateien
  'file-text': 'bi-file-earmark-text',
  'file': 'bi-file-earmark',
  'document': 'bi-file-earmark-text',
  'dokument': 'bi-file-earmark-text',
  'angebot': 'bi-file-earmark-text',
  'angebote': 'bi-file-earmark-text',
  'archive': 'bi-archive',
  'archiv': 'bi-archive',

  // Vertrieb & Marketing
  'target': 'bi-bullseye',
  'opportunities': 'bi-bullseye',
  'sales': 'bi-graph-up',
  'vertrieb': 'bi-graph-up',
  'trending-up': 'bi-graph-up',
  'marketing': 'bi-graph-up',
  'kampagnen': 'bi-graph-up',
  'campaigns': 'bi-graph-up',

  // Finanzen
  'dollar-sign': 'bi-currency-dollar',
  'money': 'bi-currency-dollar',
  'euro': 'bi-currency-euro',
  'finanzen': 'bi-currency-euro',
  'payment': 'bi-credit-card',
  'credit-card': 'bi-credit-card',
  'card': 'bi-credit-card',
  'rechnung': 'bi-receipt',
  'rechnungen': 'bi-receipt',
  'invoice': 'bi-receipt',

  // Berichte & Analytics
  'bar-chart-3': 'bi-bar-chart',
  'chart': 'bi-bar-chart',
  'analytics': 'bi-bar-chart',
  'berichte': 'bi-bar-chart',
  'reports': 'bi-bar-chart',
  'file-bar-chart': 'bi-file-earmark-text',
  'statistics': 'bi-graph-up',
  'stats': 'bi-graph-up',
  'chart-column': 'bi-bar-chart',

  // Administration
  'settings': 'bi-gear',
  'einstellungen': 'bi-gear',
  'admin': 'bi-gear',
  'shield': 'bi-shield-lock',
  'security': 'bi-shield-lock',
  'sicherheit': 'bi-shield-lock',
  'benutzer': 'bi-person-lock',
  'permissions': 'bi-person-lock',
  'berechtigungen': 'bi-person-lock',
  'lock': 'bi-lock',
  'unlock': 'bi-unlock',

  // Service & Support
  'help-circle': 'bi-question-circle',
  'support': 'bi-question-circle',
  'hilfe': 'bi-question-circle',
  'book-open': 'bi-book',
  'documentation': 'bi-book',
  'docs': 'bi-book',
  'wissensbasis': 'bi-book',
  'knowledge': 'bi-book',

  // Tools & Utilities
  'wrench': 'bi-wrench',
  'tools': 'bi-tools',
  'utilities': 'bi-tools',
  'werkzeuge': 'bi-tools',
  'palette': 'bi-palette',
  'design': 'bi-palette',
  'theme': 'bi-palette',
  'themes': 'bi-palette',
  'colors': 'bi-palette',
  'farben': 'bi-palette',

  // Technisch
  'database': 'bi-database',
  'datenbank': 'bi-database',
  'data': 'bi-database',
  'daten': 'bi-database',
  'globe': 'bi-globe',
  'web': 'bi-globe',
  'internet': 'bi-globe',
  'api': 'bi-globe',
  'integration': 'bi-link-45deg',
  'link': 'bi-link-45deg',
  'external-link': 'bi-box-arrow-up-right',

  // Workflow & Prozesse
  'briefcase': 'bi-briefcase',
  'business': 'bi-briefcase',
  'work': 'bi-briefcase',
  'projekt': 'bi-briefcase',
  'projekte': 'bi-briefcase',
  'projects': 'bi-briefcase',
  'package': 'bi-box',
  'paket': 'bi-box',
  'truck': 'bi-truck',
  'delivery': 'bi-truck',
  'lieferung': 'bi-truck',

  // Interaktion
  'plus': 'bi-plus',
  'add': 'bi-plus',
  'neu': 'bi-plus',
  'new': 'bi-plus',
  'hinzufuegen': 'bi-plus',
  'search': 'bi-search',
  'suche': 'bi-search',
  'filter': 'bi-funnel',
  'edit': 'bi-pencil-square',
  'bearbeiten': 'bi-pencil-square',
  'modify': 'bi-pencil-square',
  'trash-2': 'bi-trash',
  'delete': 'bi-trash',
  'loeschen': 'bi-trash',
  'remove': 'bi-trash',

  // Status & Feedback
  'check': 'bi-check',
  'success': 'bi-check',
  'erfolgreich': 'bi-check',
  'ok': 'bi-check',
  'x': 'bi-x-lg',
  'error': 'bi-x-lg',
  'fehler': 'bi-x-lg',
  'close': 'bi-x-lg',
  'alert-circle': 'bi-exclamation-circle',
  'warning': 'bi-exclamation-triangle',
  'warnung': 'bi-exclamation-triangle',
  'info': 'bi-info-circle',
  'information': 'bi-info-circle',
  'star': 'bi-star',
  'favorite': 'bi-star',
  'favorit': 'bi-star',
  'heart': 'bi-heart',
  'like': 'bi-heart',

  // Navigation & Layout
  'menu': 'bi-list',
  'navigation': 'bi-list',
  'nav': 'bi-list',
  'aktionen': 'bi-lightning',
  'office': 'bi-building',
  'bestellungen': 'bi-basket',
  'fakturierung': 'bi-receipt',
  'umsätze': 'bi-cash-coin',
  'umsaetze': 'bi-cash-coin',
  'stammdaten': 'bi-card-list',
  'meetings': 'bi-calendar-event',
  'auswertungen': 'bi-graph-up',
  'einstellungen': 'bi-gear',
  'hidden': 'bi-eye-slash',
  'more-horizontal': 'bi-three-dots',
  'more-vertical': 'bi-three-dots-vertical',
  'options': 'bi-three-dots',
  'grid': 'bi-grid',
  'raster': 'bi-grid',
  'list': 'bi-list',
  'liste': 'bi-list',
  'layout': 'bi-layout-text-window-reverse',
  'maximize': 'bi-fullscreen',
  'minimize': 'bi-fullscreen-exit',
  'fullscreen': 'bi-fullscreen',
  'refresh': 'bi-arrow-repeat',
  'reload': 'bi-arrow-repeat',
  'aktualisieren': 'bi-arrow-repeat',

  // Pfeile & Richtungen
  'arrow-left': 'bi-arrow-left',
  'arrow-right': 'bi-arrow-right',
  'arrow-up': 'bi-arrow-up',
  'arrow-down': 'bi-arrow-down',
  'chevron-right': 'bi-chevron-right',

  // Import/Export
  'download': 'bi-download',
  'export': 'bi-download',
  'exportieren': 'bi-download',
  'upload': 'bi-upload',
  'import': 'bi-upload',
  'importieren': 'bi-upload',
  'save': 'bi-save',
  'speichern': 'bi-save',
  'copy': 'bi-clipboard',
  'kopieren': 'bi-clipboard',

  // Sichtbarkeit
  'eye': 'bi-eye',
  'show': 'bi-eye',
  'anzeigen': 'bi-eye',
  'eye-off': 'bi-eye-slash',
  'hide': 'bi-eye-slash',
  'verstecken': 'bi-eye-slash',

  // Fallback
  'circle': 'bi-circle',
  'default': 'bi-circle',
  'unknown': 'bi-circle',
};

// FontAwesome → Bootstrap Icons Übersetzungen (häufige Fälle)
const FA_TO_BOOTSTRAP_ALIAS = {
  'home': 'house',
  'tachometer': 'speedometer2',
  'tachometer-alt': 'speedometer2',
  'dashboard': 'speedometer2',
  'cog': 'gear',
  'cogs': 'gear',
  'user': 'person',
  'users': 'people',
  'shopping-cart': 'cart',
  'cart-shopping': 'cart',
  'file-text': 'file-earmark-text',
  'file-alt': 'file-earmark-text',
  'file': 'file-earmark',
  'envelope': 'envelope',
  'phone': 'telephone',
  'dollar-sign': 'currency-dollar',
  'euro-sign': 'currency-euro',
  'euro': 'currency-euro',
  'money-bill': 'cash',
  'money-bill-wave': 'cash',
  'chart-line': 'graph-up',
  'chart-bar': 'bar-chart',
  'calendar': 'calendar3',
  'lock': 'lock',
  'unlock': 'unlock',
  'bell': 'bell',
  'comment': 'chat-left-text',
  'comments': 'chat-left-text',
  'history': 'clock',
  'database': 'database',
  'globe': 'globe',
  'link': 'link-45deg',
  'external-link-alt': 'box-arrow-up-right',
  'search': 'search',
  'filter': 'funnel',
  'edit': 'pencil-square',
  'trash': 'trash',
  'download': 'download',
  'upload': 'upload',
  'save': 'save',
  'copy': 'clipboard',
  'eye': 'eye',
  'eye-slash': 'eye-slash',
  'star': 'star',
  'heart': 'heart',
  'plus': 'plus',
  'bolt': 'lightning',
  'minus': 'dash',
  'times': 'x-lg',
  'close': 'x-lg',
  'xmark': 'x-lg',
};

function normalizeBootstrapIconName(rawName) {
  if (!rawName || typeof rawName !== 'string') return null;
  const name = rawName.trim();

  // Falls Formate wie "bi bi-house" oder "bi-house" übergeben werden
  const biToken = name
    .split(/\s+/)
    .find((t) => t.startsWith('bi-'));
  if (biToken) {
    return applyBootstrapRenames(biToken); // z.B. bi-house, bi-speedometer2
  }

  // Präfix-Formate: "bootstrap:house", "bs:house-door"
  const prefixMatch = name.match(/^([a-z]+)\s*:\s*([a-z0-9-]+)$/i);
  if (prefixMatch) {
    const prefix = prefixMatch[1].toLowerCase();
    const icon = prefixMatch[2];
    if (BOOTSTRAP_ICON_PREFIXES.includes(prefix)) {
      return applyBootstrapRenames(`bi-${icon}`);
    }
  }

  // FontAwesome Klassen → Bootstrap mappen
  // Beispiele: "fa fa-home", "fas fa-tachometer-alt", "fa-users"
  const tokens = name.split(/\s+/);
  const hasFaPrefix = tokens.some((t) => FA_PREFIXES.includes(t.toLowerCase()));
  const faToken = tokens
    .filter((t) => t.toLowerCase().startsWith('fa-'))
    .sort((a, b) => b.length - a.length)[0];
  if (hasFaPrefix || faToken) {
    let faName = faToken ? faToken.replace(/^fa-/, '') : null;
    if (!faName) {
      // Falls nur "fa"/"fas" etc. ohne fa-Token übergeben wurde, versuche letzten Token zu verwenden
      const last = tokens[tokens.length - 1];
      if (last && /^[a-z0-9-]+$/i.test(last)) faName = last.toLowerCase();
    }
    if (faName) {
      const mapped = FA_TO_BOOTSTRAP_ALIAS[faName] || faName;
      return applyBootstrapRenames(`bi-${mapped}`);
    }
  }

  return null;
}

function createBootstrapIconComponent(biClassName) {
  const BootstrapIcon = ({ className, size = 16, style, ...props }) => {
    const combinedClass = ['bi', biClassName, className].filter(Boolean).join(' ');
    const finalStyle = {
      fontSize: typeof size === 'number' ? `${size}px` : size,
      lineHeight: 1,
      ...style,
    };
    return <i className={combinedClass} style={finalStyle} aria-hidden="true" {...props} />;
  };
  return BootstrapIcon;
}

// Fallback: leeres Symbol, keine Glyph
const NullIcon = ({ className, size = 16, style, ...props }) => {
  const finalStyle = {
    display: 'inline-block',
    width: typeof size === 'number' ? `${size}px` : size,
    height: typeof size === 'number' ? `${size}px` : size,
    lineHeight: 1,
    ...style,
  };
  return <i className={className} style={finalStyle} aria-hidden="true" {...props} />;
};

// Haupt-Icon-Mapping für Menü-Icons aus der Datenbank
export const MENU_ICON_MAP = {
  // Haupt-Bereiche
  'home': Home,
  'dashboard': LayoutDashboard,
  'layoutdashboard': LayoutDashboard,
  'users': Users,
  'user': User,
  'building': Building,
  'building2': Building2,
  'company': Building,
  'unternehmen': Building2,
  
  // Aktivitäten
  'calendar': Calendar,
  'termine': Calendar,
  'clock': Clock,
  'time': Clock,
  'aufgaben': Clock,
  'tasks': Clock,
  
  // Kommunikation
  'mail': Mail,
  'email': Mail,
  'phone': Phone,
  'telefon': Phone,
  'message-square': MessageSquare,
  'messages': MessageSquare,
  'nachrichten': MessageSquare,
  'chat': MessageSquare,
  'bell': Bell,
  'notifications': Bell,
  
  // Dokumente & Dateien
  'file-text': FileText,
  'file': FileText,
  'document': FileText,
  'dokument': FileText,
  'angebot': FileText,
  'angebote': FileText,
  'archive': Archive,
  'archiv': Archive,
  
  // Vertrieb & Marketing
  'target': Target,
  'opportunities': Target,
  'sales': Target,
  'vertrieb': Target,
  'trending-up': TrendingUp,
  'marketing': TrendingUp,
  'kampagnen': TrendingUp,
  'campaigns': TrendingUp,
  
  // Finanzen
  'dollar-sign': DollarSign,
  'money': DollarSign,
  'euro': DollarSign,
  'finanzen': DollarSign,
  'payment': DollarSign,
  'credit-card': CreditCard,
  'card': CreditCard,
  'rechnung': CreditCard,
  'rechnungen': CreditCard,
  'invoice': CreditCard,
  
  // Berichte & Analytics
  'bar-chart-3': BarChart3,
  'chart': BarChart3,
  'analytics': BarChart3,
  'berichte': BarChart3,
  'reports': BarChart3,
  'file-bar-chart': FileBarChart,
  'statistics': FileBarChart,
  'stats': FileBarChart,
  
  // Administration
  'settings': Settings,
  'einstellungen': Settings,
  'admin': Settings,
  'shield': Shield,
  'security': Shield,
  'sicherheit': Shield,
  'benutzer': Shield,
  'permissions': Shield,
  'berechtigungen': Shield,
  'lock': Lock,
  'unlock': Unlock,
  
  // Service & Support
  'help-circle': HelpCircle,
  'help': HelpCircle,
  'support': HelpCircle,
  'hilfe': HelpCircle,
  'book-open': BookOpen,
  'documentation': BookOpen,
  'docs': BookOpen,
  'wissensbasis': BookOpen,
  'knowledge': BookOpen,
  
  // Tools & Utilities
  'wrench': Wrench,
  'tools': Wrench,
  'utilities': Wrench,
  'werkzeuge': Wrench,
  'palette': Palette,
  'design': Palette,
  'theme': Palette,
  'themes': Palette,
  'colors': Palette,
  'farben': Palette,
  
  // Technisch
  'database': Database,
  'datenbank': Database,
  'data': Database,
  'daten': Database,
  'globe': Globe,
  'web': Globe,
  'internet': Globe,
  'api': Globe,
  'integration': Globe,
  'link': Link,
  'external-link': ExternalLink,
  
  // Workflow & Prozesse
  'briefcase': Briefcase,
  'business': Briefcase,
  'work': Briefcase,
  'projekt': Briefcase,
  'projekte': Briefcase,
  'projects': Briefcase,
  'package': Package,
  'paket': Package,
  'truck': Truck,
  'delivery': Truck,
  'lieferung': Truck,
  
  // Interaktion
  'plus': Plus,
  'add': Plus,
  'neu': Plus,
  'new': Plus,
  'hinzufuegen': Plus,
  'search': Search,
  'suche': Search,
  'filter': Filter,
  'edit': Edit,
  'bearbeiten': Edit,
  'modify': Edit,
  'trash-2': Trash2,
  'delete': Trash2,
  'loeschen': Trash2,
  'remove': Trash2,
  
  // Status & Feedback
  'check': Check,
  'success': Check,
  'erfolgreich': Check,
  'ok': Check,
  'x': X,
  'error': X,
  'fehler': X,
  'close': X,
  'alert-circle': AlertCircle,
  'warning': AlertCircle,
  'warnung': AlertCircle,
  'info': Info,
  'information': Info,
  'star': Star,
  'favorite': Star,
  'favorit': Star,
  'heart': Heart,
  'like': Heart,
  
  // Navigation & Layout
  'menu': Menu,
  'navigation': Menu,
  'nav': Menu,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  'options': MoreHorizontal,
  'grid': Grid,
  'raster': Grid,
  'list': List,
  'liste': List,
  'layout': Layout,
  'maximize': Maximize,
  'minimize': Minimize,
  'fullscreen': Maximize,
  'refresh': Refresh,
  'reload': Refresh,
  'aktualisieren': Refresh,
  
  // Pfeile & Richtungen
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'chevron-right': ChevronRight,
  
  // Import/Export
  'download': Download,
  'export': Download,
  'exportieren': Download,
  'upload': Upload,
  'import': Upload,
  'importieren': Upload,
  'save': Save,
  'speichern': Save,
  'copy': Copy,
  'kopieren': Copy,
  
  // Sichtbarkeit
  'eye': Eye,
  'show': Eye,
  'anzeigen': Eye,
  'eye-off': EyeOff,
  'hide': EyeOff,
  'verstecken': EyeOff,
  
  // Sharing
  'share': Share,
  'teilen': Share,
  'share-2': Share,
  
  // Fallback
  'circle': Circle,
  'default': Circle,
  'unknown': Circle,
  '': Circle,
  null: Circle,
  undefined: Circle,

  // Menu Builder Icons (Lucide) - case-sensitive names
  'gift': Gift,
  'shoppingcart': ShoppingCart,
  'shopping-cart': ShoppingCart,
  'map': Map,
  'calculator': Calculator,
  'receipt': Receipt,
  'table': Table,
  'filesignature': FileSignature,
  'file-signature': FileSignature,
  'handcoins': HandCoins,
  'hand-coins': HandCoins,
  'zap': Zap,
  'store': Store,
  'marketplace': Store,
  'usercircle': UserCircle,
  'user-circle': UserCircle,
  'usercog': UserCog,
  'user-cog': UserCog,

  // ============================================
  // Menu Builder PascalCase -> lowercase mappings
  // (Lucide components stored in DB as PascalCase)
  // ============================================
  'activity': Activity,
  // 'scale' = Waage: Offert-Vergleich. Stand 26.08.2026 stand im Menü (Eintrag
  // 13244) bereits das Icon "Scale", fiel aber durch ALLE fünf Auflösungsstufen
  // in den NullIcon — der Punkt war schlicht ohne Symbol. Lucide liefert das
  // Icon, es fehlte nur hier in der Map.
  'scale': Scale,
  'send': Send,
  'filetext': FileText,
  'folder': Folder,
  'folderopen': FolderOpen,
  'folder-open': FolderOpen,
  'image': Image,
  'video': Video,
  'music': Music,
  'box': Box,
  'boxes': Boxes,
  'layers': Layers,
  'pentool': PenTool,
  'pen-tool': PenTool,
  'scissors': Scissors,
  'clipboard': Clipboard,
  'clipboardlist': ClipboardList,
  'clipboard-list': ClipboardList,
  'clipboardcheck': ClipboardCheck,
  'clipboard-check': ClipboardCheck,
  'bookmark': Bookmark,
  'tag': Tag,
  'tags': Tags,
  'hash': Hash,
  'atsign': AtSign,
  'at-sign': AtSign,
  'smile': Smile,
  'frown': Frown,
  'meh': Meh,
  'thumbsup': ThumbsUp,
  'thumbs-up': ThumbsUp,
  'thumbsdown': ThumbsDown,
  'thumbs-down': ThumbsDown,
  'award': Award,
  'medal': Medal,
  'trophy': Trophy,
  'crown': Crown,
  'flame': Flame,
  'sparkles': Sparkles,
  'lightbulb': Lightbulb,
  'power': Power,
  'battery': Battery,
  'wifi': Wifi,
  'bluetooth': Bluetooth,
  'headphones': Headphones,
  'speaker': Speaker,
  'monitor': Monitor,
  'laptop': Laptop,
  'smartphone': Smartphone,
  'tablet': Tablet,
  'printer': Printer,
  'harddrive': HardDrive,
  'hard-drive': HardDrive,
  'cpu': Cpu,
  'server': Server,
  'cloud': Cloud,
  'clouddownload': CloudDownload,
  'cloud-download': CloudDownload,
  'cloudupload': CloudUpload,
  'cloud-upload': CloudUpload,
  'coffee': Coffee,
  'utensils': Utensils,
  'pizza': Pizza,
  'apple': Apple,
  'leaf': Leaf,
  'sun': Sun,
  'moon': Moon,
  'cloudrain': CloudRain,
  'cloud-rain': CloudRain,
  'snowflake': Snowflake,
  'wind': Wind,
  'thermometer': Thermometer,
  'droplet': Droplet,
  'umbrella': Umbrella,
  'compass': Compass,
  'mappin': MapPin,
  'map-pin': MapPin,
  'navigation': Navigation,
  'plane': Plane,
  'car': Car,
  'bus': Bus,
  'train': Train,
  'ship': Ship,
  'anchor': Anchor,
  'bike': Bike,
  'key': Key,
  'wallet': Wallet,
  'banknote': Banknote,
  'coins': Coins,
  'piggybank': PiggyBank,
  'piggy-bank': PiggyBank,
  'chartline': ChartLine,
  'chart-line': ChartLine,
  'chartpie': ChartPie,
  'chart-pie': ChartPie,
  'trendingdown': TrendingDown,
  'trending-down': TrendingDown,
  'percent': Percent,
  'binary': Binary,
  'code': Code,
  'terminal': Terminal,
  'bug': Bug,
  'rocket': Rocket,
  'gauge': Gauge,
  'sliders': Sliders,
  'toggleleft': ToggleLeft,
  'toggle-left': ToggleLeft,
  'toggleright': ToggleRight,
  'toggle-right': ToggleRight,
  'refreshcw': RefreshCw,
  'refresh-cw': RefreshCw,
  'rotatecw': RotateCw,
  'rotate-cw': RotateCw,
  'repeat': Repeat,
  'shuffle': Shuffle,
  'play': Play,
  'pause': Pause,
  'square': Square,
  'stop': Square,
  'stepforward': StepForward,
  'step-forward': StepForward,
  'stepback': StepBack,
  'step-back': StepBack,
  'fastforward': FastForward,
  'fast-forward': FastForward,
  'rewind': Rewind,
  'volume': Volume,
  'volume1': Volume1,
  'volume2': Volume2,
  'volumex': VolumeX,
  'volume-x': VolumeX,
  'mic': Mic,
  'micoff': MicOff,
  'mic-off': MicOff,
  'camera': Camera,
  'cameraoff': CameraOff,
  'camera-off': CameraOff,
  'film': Film,
  'aperture': Aperture,
  'focus': Focus,
  'crop': Crop,
  'move': Move,
  'maximize2': Maximize2,
  'maximize-2': Maximize2,
  'minimize2': Minimize2,
  'minimize-2': Minimize2,
  'zoomin': ZoomIn,
  'zoom-in': ZoomIn,
  'zoomout': ZoomOut,
  'zoom-out': ZoomOut,
  'cornerupleft': CornerUpLeft,
  'corner-up-left': CornerUpLeft,
  'cornerupright': CornerUpRight,
  'corner-up-right': CornerUpRight,
  'cornerdownleft': CornerDownLeft,
  'corner-down-left': CornerDownLeft,
  'cornerdownright': CornerDownRight,
  'corner-down-right': CornerDownRight,
  'chevronsup': ChevronsUp,
  'chevrons-up': ChevronsUp,
  'chevronsdown': ChevronsDown,
  'chevrons-down': ChevronsDown,
  'chevronsleft': ChevronsLeft,
  'chevrons-left': ChevronsLeft,
  'chevronsright': ChevronsRight,
  'chevrons-right': ChevronsRight,
  'chevronup': ChevronUp,
  'chevron-up': ChevronUp,
  'chevrondown': ChevronDown,
  'chevron-down': ChevronDown,
  'chevronleft': ChevronLeft,
  'chevron-left': ChevronLeft,
  'arrowupright': ArrowUpRight,
  'arrow-up-right': ArrowUpRight,
  'arrowdownright': ArrowDownRight,
  'arrow-down-right': ArrowDownRight,
  'arrowupleft': ArrowUpLeft,
  'arrow-up-left': ArrowUpLeft,
  'arrowdownleft': ArrowDownLeft,
  'arrow-down-left': ArrowDownLeft,
  'alignleft': AlignLeft,
  'align-left': AlignLeft,
  'aligncenter': AlignCenter,
  'align-center': AlignCenter,
  'alignright': AlignRight,
  'align-right': AlignRight,
  'alignjustify': AlignJustify,
  'align-justify': AlignJustify,
  'bold': Bold,
  'italic': Italic,
  'underline': Underline,
  'strikethrough': Strikethrough,
  'type': Type,
  'heading1': Heading1,
  'heading-1': Heading1,
  'heading2': Heading2,
  'heading-2': Heading2,
  'heading3': Heading3,
  'heading-3': Heading3,
  'listordered': ListOrdered,
  'list-ordered': ListOrdered,
  'listtodo': ListTodo,
  'list-todo': ListTodo,
  'quote': Quote,
  'code2': Code2,
  'code-2': Code2,
  'filecode': FileCode,
  'file-code': FileCode,
  'filejson': FileJson,
  'file-json': FileJson,
  'filespreadsheet': FileSpreadsheet,
  'file-spreadsheet': FileSpreadsheet,
  'filepdf': FileText,
  'file-pdf': FileText,
  'fileimage': FileImage,
  'file-image': FileImage,
  'filevideo': FileVideo,
  'file-video': FileVideo,
  'fileaudio': FileAudio,
  'file-audio': FileAudio,
  'filearchive': FileArchive,
  'file-archive': FileArchive,
  'fileplus': FilePlus,
  'file-plus': FilePlus,
  'fileminus': FileMinus,
  'file-minus': FileMinus,
  'filecheck': FileCheck,
  'file-check': FileCheck,
  'filex': FileX,
  'file-x': FileX,
  'folderplus': FolderPlus,
  'folder-plus': FolderPlus,
  'folderminus': FolderMinus,
  'folder-minus': FolderMinus,
  'foldercheck': FolderCheck,
  'folder-check': FolderCheck,
  'folderx': FolderX,
  'folder-x': FolderX,
  'trash': Trash,
  'link2': Link2,
  'link-2': Link2,
  'link2off': Link2Off,
  'link-2-off': Link2Off,
  'unlink': Unlink,
  'paperclip': Paperclip,
  'pin': Pin,
  'pinoff': PinOff,
  'pin-off': PinOff,
  'flag': Flag,
  'milestone': Milestone,
  'signalhigh': SignalHigh,
  'signal-high': SignalHigh,
  'signalmedium': SignalMedium,
  'signal-medium': SignalMedium,
  'signallow': SignalLow,
  'signal-low': SignalLow,
  'wifioff': WifiOff,
  'wifi-off': WifiOff,
  'radio': Radio,
  'tv': Tv,
  'tv2': Tv2,
  'tv-2': Tv2,
  'cable': Cable,
  'plug': Plug,
  'plugzap': PlugZap,
  'plug-zap': PlugZap,
  'batterycharging': BatteryCharging,
  'battery-charging': BatteryCharging,
  'batteryfull': BatteryFull,
  'battery-full': BatteryFull,
  'batterymedium': BatteryMedium,
  'battery-medium': BatteryMedium,
  'batterylow': BatteryLow,
  'battery-low': BatteryLow,
  'batterywarning': BatteryWarning,
  'battery-warning': BatteryWarning,
  'qrcode': QrCode,
  'qr-code': QrCode,
  'barcode': Barcode,
  'scan': Scan,
  'scanline': ScanLine,
  'scan-line': ScanLine,
  'fingerprint': Fingerprint,
  'usercheck': UserCheck,
  'user-check': UserCheck,
  'userminus': UserMinus,
  'user-minus': UserMinus,
  'userplus': UserPlus,
  'user-plus': UserPlus,
  'userx': UserX,
  'user-x': UserX,
  'users2': Users2,
  'users-2': Users2,
  'usersround': UsersRound,
  'users-round': UsersRound,
  'userround': UserRound,
  'user-round': UserRound,
  'contact': Contact,
  'contact2': Contact2,
  'contact-2': Contact2,
  'circleuser': CircleUser,
  'circle-user': CircleUser,
  'badgecheck': BadgeCheck,
  'badge-check': BadgeCheck,
  'badgealert': BadgeAlert,
  'badge-alert': BadgeAlert,
  'badgedollarsign': BadgeDollarSign,
  'badge-dollar-sign': BadgeDollarSign,
  'badgepercent': BadgePercent,
  'badge-percent': BadgePercent,
  'badgeplus': BadgePlus,
  'badge-plus': BadgePlus,
  'badgeminus': BadgeMinus,
  'badge-minus': BadgeMinus,
  'badgex': BadgeX,
  'badge-x': BadgeX,
  'verified': Verified,
  'shieldcheck': ShieldCheck,
  'shield-check': ShieldCheck,
  'shieldx': ShieldX,
  'shield-x': ShieldX,
  'shieldoff': ShieldOff,
  'shield-off': ShieldOff,
  'shieldquestion': ShieldQuestion,
  'shield-question': ShieldQuestion,
  'lockkeyhole': LockKeyhole,
  'lock-keyhole': LockKeyhole,
  'unlockkeyhole': UnlockKeyhole,
  'unlock-keyhole': UnlockKeyhole,
  'keyround': KeyRound,
  'key-round': KeyRound,
  'keysquare': KeySquare,
  'key-square': KeySquare
};

// Funktion zum Abrufen einer Icon-Komponente
// Font Awesome 5 Unterstützung
const FA_STYLE_PREFIXES = ['fas', 'far', 'fal', 'fab', 'fad'];

const FA_ICON_ALIAS = {
  // Haupt-Bereiche
  'home': 'home',
  'house': 'home',
  'dashboard': 'tachometer-alt',
  'users': 'users',
  'user': 'user',
  'building': 'building',
  'company': 'building',
  'unternehmen': 'building',

  // Aktivitäten
  'calendar': 'calendar-alt',
  'termine': 'calendar-alt',
  'clock': 'clock',
  'time': 'clock',
  'aufgaben': 'tasks',
  'tasks': 'tasks',

  // Kommunikation
  'mail': 'envelope',
  'email': 'envelope',
  'phone': 'phone',
  'telefon': 'phone',
  'message-square': 'comment',
  'messages': 'comments',
  'nachrichten': 'comments',
  'chat': 'comments',
  'bell': 'bell',
  'notifications': 'bell',

  // Dokumente & Dateien
  'file-text': 'file-alt',
  'file': 'file',
  'document': 'file-alt',
  'dokument': 'file-alt',
  'angebot': 'file-alt',
  'angebote': 'file-alt',
  'archive': 'archive',
  'archiv': 'archive',

  // Vertrieb & Marketing
  'target': 'bullseye',
  'opportunities': 'bullseye',
  'sales': 'chart-line',
  'vertrieb': 'chart-line',
  'trending-up': 'chart-line',
  'marketing': 'chart-line',
  'kampagnen': 'chart-line',
  'campaigns': 'chart-line',

  // Finanzen
  'dollar-sign': 'dollar-sign',
  'money': 'dollar-sign',
  'euro': 'euro-sign',
  'finanzen': 'euro-sign',
  'payment': 'credit-card',
  'credit-card': 'credit-card',
  'card': 'credit-card',
  'rechnung': 'file-invoice',
  'rechnungen': 'file-invoice',
  'invoice': 'file-invoice',

  // Berichte & Analytics
  'bar-chart-3': 'chart-bar',
  'chart': 'chart-bar',
  'analytics': 'chart-bar',
  'berichte': 'chart-bar',
  'reports': 'chart-bar',
  'file-bar-chart': 'chart-bar',
  'statistics': 'chart-line',
  'stats': 'chart-line',
  'chart-column': 'chart-bar',

  // Administration
  'settings': 'cog',
  'einstellungen': 'cog',
  'admin': 'cog',
  'shield': 'shield-alt',
  'security': 'shield-alt',
  'sicherheit': 'shield-alt',
  'benutzer': 'user-shield',
  'permissions': 'user-shield',
  'berechtigungen': 'user-shield',
  'lock': 'lock',
  'unlock': 'unlock',

  // Service & Support
  'help-circle': 'question-circle',
  'help': 'question-circle',
  'support': 'question-circle',
  'hilfe': 'question-circle',
  'book-open': 'book',
  'documentation': 'book',
  'docs': 'book',
  'wissensbasis': 'book',
  'knowledge': 'book',

  // Tools & Utilities
  'wrench': 'wrench',
  'tools': 'tools',
  'utilities': 'tools',
  'werkzeuge': 'tools',
  'palette': 'palette',
  'design': 'palette',
  'theme': 'palette',
  'themes': 'palette',
  'colors': 'palette',
  'farben': 'palette',

  // Technisch
  'database': 'database',
  'datenbank': 'database',
  'data': 'database',
  'daten': 'database',
  'globe': 'globe',
  'web': 'globe',
  'internet': 'globe',
  'api': 'globe',
  'integration': 'link',
  'link': 'link',
  'external-link': 'external-link-alt',

  // Workflow & Prozesse
  'briefcase': 'briefcase',
  'business': 'briefcase',
  'work': 'briefcase',
  'projekt': 'briefcase',
  'projekte': 'briefcase',
  'projects': 'briefcase',
  'package': 'box',
  'paket': 'box',
  'truck': 'truck',
  'delivery': 'truck',
  'lieferung': 'truck',

  // Interaktion
  'plus': 'plus',
  'add': 'plus',
  'neu': 'plus',
  'new': 'plus',
  'hinzufuegen': 'plus',
  'search': 'search',
  'suche': 'search',
  'filter': 'filter',
  'edit': 'edit',
  'bearbeiten': 'edit',
  'modify': 'edit',
  'trash-2': 'trash',
  'delete': 'trash',
  'loeschen': 'trash',
  'remove': 'trash',

  // Status & Feedback
  'check': 'check',
  'success': 'check',
  'erfolgreich': 'check',
  'ok': 'check',
  'x': 'times',
  'error': 'times',
  'fehler': 'times',
  'close': 'times',
  'alert-circle': 'exclamation-circle',
  'warning': 'exclamation-triangle',
  'warnung': 'exclamation-triangle',
  'info': 'info-circle',
  'information': 'info-circle',
  'star': 'star',
  'favorite': 'star',
  'favorit': 'star',
  'heart': 'heart',
  'like': 'heart',

  // Navigation & Layout (Titel-Aliase aus deinem Menü)
  'aktionen': 'bolt',
  'office': 'building',
  'bestellungen': 'shopping-basket',
  'fakturierung': 'dollar-sign',
  'umsätze': 'chart-line',
  'umsaetze': 'chart-line',
  'stammdaten': 'database',
  'meetings': 'calendar-alt',
  'auswertungen': 'chart-bar',
  'einstellungen': 'cog',
  'hidden': 'eye-slash',
  'menu': 'bars',
  'navigation': 'bars',
  'nav': 'bars',
  'more-horizontal': 'ellipsis-h',
  'more-vertical': 'ellipsis-v',
  'options': 'ellipsis-h',
  'grid': 'th',
  'raster': 'th',
  'list': 'list',
  'liste': 'list',
  'layout': 'th-large',
  'maximize': 'expand',
  'minimize': 'compress',
  'fullscreen': 'expand',
  'refresh': 'sync',
  'reload': 'sync',
  'aktualisieren': 'sync',

  // Pfeile & Richtungen
  'arrow-left': 'arrow-left',
  'arrow-right': 'arrow-right',
  'arrow-up': 'arrow-up',
  'arrow-down': 'arrow-down',
  'chevron-right': 'chevron-right',

  // Import/Export
  'download': 'download',
  'export': 'download',
  'exportieren': 'download',
  'upload': 'upload',
  'import': 'upload',
  'importieren': 'upload',
  'save': 'save',
  'speichern': 'save',
  'copy': 'copy',
  'kopieren': 'copy',

  // Sichtbarkeit
  'eye': 'eye',
  'show': 'eye',
  'anzeigen': 'eye',
  'eye-off': 'eye-slash',
  'hide': 'eye-slash',
  'verstecken': 'eye-slash',
};

function normalizeFontAwesomeIconName(rawName) {
  if (!rawName || typeof rawName !== 'string') return null;
  const name = rawName.trim();
  const tokens = name.split(/\s+/);

  // Direkte Klassen: "fas fa-home", "far fa-user", "fa fa-home"
  const styleToken = tokens.find((t) => FA_STYLE_PREFIXES.includes(t.toLowerCase())) || 'fas';
  const faToken = tokens
    .filter((t) => t.toLowerCase().startsWith('fa-'))
    .sort((a, b) => b.length - a.length)[0];
  if (faToken) {
    const icon = faToken.replace(/^fa-/, '');
    return { style: styleToken.toLowerCase(), icon };
  }

  // Präfix-Formate: "fa:home", "far:calendar-alt", "fontawesome:bolt"
  const prefixMatch = name.match(/^([a-z]{2,10})\s*:\s*([a-z0-9-]+)$/i);
  if (prefixMatch) {
    let prefix = prefixMatch[1].toLowerCase();
    const icon = prefixMatch[2];
    if (prefix === 'fa' || prefix === 'fa5' || prefix === 'fontawesome') prefix = 'fas';
    if (FA_STYLE_PREFIXES.includes(prefix)) {
      return { style: prefix, icon };
    }
  }

  return null;
}

function createFontAwesomeIconComponent(style, iconName) {
  const FaIcon = ({ className, size = 16, style: cssStyle, ...props }) => {
    const classes = [style || 'fas', `fa-${iconName}`, className]
      .filter(Boolean)
      .join(' ');
    const finalStyle = {
      fontSize: typeof size === 'number' ? `${size}px` : size,
      lineHeight: 1,
      ...cssStyle,
    };
    return <i className={classes} style={finalStyle} aria-hidden="true" {...props} />;
  };
  return FaIcon;
}

export function getMenuIcon(iconName) {
  if (!iconName || typeof iconName !== 'string') {
    return NullIcon;
  }

  const normalizedName = iconName.toLowerCase().trim();

  if (MENU_ICON_MAP[normalizedName]) {
    return MENU_ICON_MAP[normalizedName];
  }

  // 1) Direkte Font Awesome Klassen
  const fa = normalizeFontAwesomeIconName(iconName);
  if (fa) {
    return createFontAwesomeIconComponent(fa.style, fa.icon);
  }

  // 2) Aliase (de/en)
  if (FA_ICON_ALIAS[normalizedName]) {
    return createFontAwesomeIconComponent('fas', FA_ICON_ALIAS[normalizedName]);
  }

  // 3) Bootstrap Aliase
  const bootstrapAlias = BOOTSTRAP_ICON_ALIAS[normalizedName];
  if (bootstrapAlias) {
    return createBootstrapIconComponent(applyBootstrapRenames(bootstrapAlias));
  }

  // 4) Direkte Bootstrap Klassennamen
  const normalizedBootstrap = normalizeBootstrapIconName(iconName);
  if (normalizedBootstrap) {
    return createBootstrapIconComponent(normalizedBootstrap);
  }

  // 5) Fallback: leer
  return NullIcon;
}

// Hilfsfunktion für Icon-Komponenten mit Props
export function MenuIcon({ name, className, size = 16, ...props }) {
  const IconComponent = getMenuIcon(name);
  
  return <IconComponent className={className} size={size} {...props} />;
}

// Exportiere alle Icons für direkten Zugriff
export {
  Home, Users, Building, Building2, FileText, Calendar, Mail, Phone, DollarSign,
  BarChart3, Settings, Shield, Clock, Archive, MessageSquare, Bell,
  User, Briefcase, CreditCard, Truck, Package, Target, TrendingUp,
  FileBarChart, Database, Globe, HelpCircle, BookOpen, Wrench, Palette,
  Circle, ChevronRight, Plus, Search, Filter, Edit, Trash2, Download,
  Upload, Save, Copy, Eye, EyeOff, Lock, Unlock, Check, X, AlertCircle,
  Info, Star, Heart, Share, Link, ExternalLink, Menu, MoreHorizontal,
  MoreVertical, Grid, List, Layout, LayoutDashboard, Maximize, Minimize, Refresh,
  ArrowLeft, ArrowRight, ArrowUp, ArrowDown
};
